import './style.scss';
import { Slider } from '../../../js/components/Slider/Slider';

export default !function () {
  const blocks = document.querySelectorAll('.universal-gallery-lg-v1');

  if (!blocks.length) {
    return;
  }

  blocks.forEach((block) => {
    const sliderContainer = block.querySelector('.universal-gallery-lg-v1__slider');
    const slides = sliderContainer.querySelectorAll('.universal-gallery-lg-v1__item');
    const controls = sliderContainer.querySelector('.universal-gallery-lg-v1__controls');
    const isInit = slides.length > 1;

    const options = {
      wrapper: sliderContainer,
      settings: {
        spaceBetween: 8,

        effect: 'slide',
        fadeEffect: {
          crossFade: true
        },

        slideClass: 'universal-gallery-lg-v1__item',
        wrapperClass: 'universal-gallery-lg-v1__list',

        pagination: {
          el: '.js-slider-count',
          type: 'fraction',
        },

        navigation: {
          nextEl: '.button-arrow--next',
          prevEl: '.button-arrow--prev'
        },

        media: {
          lg: {
            loop: true,
            effect: 'fade'
          },
          xl: {
            loop: true,
            effect: 'fade'
          }
        },

        breakpoints: {
          768: {
            spaceBetween: 24
          },
          1024: {
            spaceBetween: 0
          }
        },
      },
      modules: ['pagination', 'navigation', 'effectFade', 'a11y'],
      initCondition: {
        sm: isInit,
        md: isInit,
        lg: isInit,
        xl: isInit
      },
      controls
    };

    new Slider(options).init();
  });
}();
